function compareInfluencersData(a, b) {
  const key = "followers_count";
  if (a[key] < b[key]) {
    return 1;
  }
  if (a[key] > b[key]) {
    return -1;
  }
  return 0;
}

export const formatInfluencersData = (d = []) => {
  let array = [];
  const data = d && d.graph_data ? d.graph_data : [];
  if (data && data.length) {
    data.forEach((item) => {
      const { topic_name, post_count } = item;
      if (post_count && post_count.length) {
        item.post_count.forEach((i) => {
          const { followers_count, from_username } = i;
          array.push({
            followers_count,
            from_username,
            topic_name,
            posts: post_count.length,
          });
        });
      }
    });
    return array.sort(compareInfluencersData);
  }
  return [];
};
